import styled from '@mui/system/styled';

export const PlusIconContainer = styled('div')({
	display: 'flex',
	alignItems: 'center',
	cursor: 'pointer',
});
